import {
  INotificationsChannelConfig,
  IUpdateNotificationsChannelParams,
} from 'multirpc-sdk';

import { MultiService } from 'modules/api/MultiService';
import { RootState } from 'store';
import {
  selectSignupSettings,
  setSignupSettings,
} from 'domains/userSettings/store/userSettingsSlice';
import { web3Api } from 'store/queries';
import { createQueryFnWithErrorHandler } from 'store/utils/createQueryFnWithErrorHandler';

export const {
  endpoints: { editNotificationSettings },
  useEditNotificationSettingsMutation,
} = web3Api.injectEndpoints({
  endpoints: build => ({
    editNotificationSettings: build.mutation<
      INotificationsChannelConfig,
      IUpdateNotificationsChannelParams
    >({
      queryFn: createQueryFnWithErrorHandler({
        queryFn: async (settings, { dispatch, getState }) => {
          const service = MultiService.getService();

          const data = await service
            .getAccountingGateway()
            .updateNotificationsChannel(settings);

          const signUpSettings = selectSignupSettings(getState() as RootState);

          dispatch(
            setSignupSettings({
              ...signUpSettings,
              hasMarketing: data?.marketing,
            }),
          );

          return { data };
        },
      }),
    }),
  }),
});
